import { AriaDescriber } from '@angular/cdk/a11y';
import { AfterViewInit, Directive, ElementRef, Input } from '@angular/core';
import { CmLocalizePipe, CmSettingsService } from '@ats/cm/core';

@Directive({
    // eslint-disable-next-line @angular-eslint/directive-selector
    selector: 'a, [cmFileDownload], [cmSSO]',
    standalone: false
})
export class CmLinkDescriptionDirective implements AfterViewInit {
	@Input() targetWindow: string;

	constructor(
		private readonly elementRef: ElementRef,
		private readonly localize: CmLocalizePipe,
		private readonly settingsService: CmSettingsService,
		private readonly ariaDescriber: AriaDescriber
	) {}

	ngAfterViewInit(): void {
		const targetValue: string = this.elementRef.nativeElement.getAttribute('target') || this.targetWindow;
		switch (targetValue) {
			case '_blank':
				this.ariaDescriber.describe(
					this.elementRef.nativeElement,
					this.localize.transform(
						'opens in new tab',
						`${this.settingsService.portalCoreFeature}/System.Global.Button.OpensInNewTab`
					)
				);
				break;
			default:
				this.ariaDescriber.describe(
					this.elementRef.nativeElement,
					this.localize.transform(
						'opens in same tab',
						`${this.settingsService.portalCoreFeature}/System.Global.Button.OpensInSameTab`
					)
				);
		}
	}
}
